import Colors from '@/constants/Colors';
import { pxToVw } from '@/modules/styled/cssUnits';
import styled from 'styled-components';

const linkLateralPadding = 20;

export const StyledTaskActivityNavLink = styled.a`
  padding: 10px ${pxToVw(linkLateralPadding)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${Colors.border};
  position: relative;

  &:first-of-type {
    border-top: 1px solid ${Colors.border};
  }
  &.locked {
    cursor: not-allowed;
    opacity: 0.5;
  }
  &.current {
    background-color: ${Colors.backgroundPaleBlueDark};
    .left .activity-type-name {
      font-weight: bold;
    }
  }

  .left {
    display: flex;
    align-items: center;
    gap: 10px;

    .activity-type-name {
      text-transform: capitalize;

      .ant-tag {
        margin-left: 10px;
      }
    }
  }

  .done-icon {
    width: calc(${pxToVw(46)} - 1px);
    height: calc(${pxToVw(46)} - 1px);
    color: ${Colors.success};
    border: 2px solid ${Colors.success};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
